import api from './api';

export interface ConsignmentInventoryItem {
  id: string;
  clinicId: string;
  assetId: string;
  productSku: string;
  productName: string | null;
  serialNumber: string;
  status: 'at_clinic' | 'fulfilled' | 'returned_to_warehouse' | 'lost';
  assignedAt: string;
  returnedAt: string | null;
  fulfilledAt: string | null;
  fulfilledForRentalId: string | null;
  notes: string | null;
  asset?: {
    id: string;
    serialNumber: string;
    assetStatus: string;
    productSku: string;
    productName: string;
  };
}

export interface ConsignmentSummary {
  totalClinics: number;
  totalUnits: number;
  clinics: Array<{
    clinicId: string;
    clinicName: string;
    totalUnits: number;
    uniqueProducts: number;
    items: Array<{
      id: string;
      serialNumber: string;
      productSku: string;
      productName: string | null;
      assignedAt: string;
    }>;
  }>;
}

export const consignmentApi = {
  getSummary: async () => {
    const { data } = await api.get<ConsignmentSummary>('/consignment/summary');
    return data;
  },

  getClinicInventory: async (clinicId: string, status?: string) => {
    const params = status ? { status } : {};
    const { data } = await api.get<ConsignmentInventoryItem[]>(
      `/consignment/clinic/${clinicId}`,
      { params },
    );
    return data;
  },

  assign: async (dto: {
    clinicId: string;
    assetId: string;
    productSku: string;
    productName?: string;
    serialNumber: string;
    notes?: string;
  }) => {
    const { data } = await api.post('/consignment/assign', dto);
    return data;
  },

  markFulfilled: async (id: string, rentalId: string) => {
    const { data } = await api.post(`/consignment/${id}/fulfill`, {
      rentalId,
    });
    return data;
  },

  markReturned: async (id: string) => {
    const { data } = await api.post(`/consignment/${id}/return`);
    return data;
  },

  markLost: async (id: string, notes?: string) => {
    const { data } = await api.post(`/consignment/${id}/lost`, { notes });
    return data;
  },

  remove: async (id: string) => {
    const { data } = await api.delete(`/consignment/${id}`);
    return data;
  },
};

export default consignmentApi;
